import React, { Component } from "react";
import * as paypal from "paypal-rest-sdk";

class Pagamento extends Component {

    state= {
        mensagem: ''
    }
m

  componentWillMount() {
    if (window.location.href.includes("state=cancel")) {
      this.setState({ mensagem: 'Você cancelou o processo de pagamento!' })
    } else if (window.location.href.includes("token=")) {
      let token = window.location.href.replace(
        "https://www.grupopw.net/pagamento?token=",
        ""
      );
      this.setState({ mensagem: 'Pagamento efetuado com sucesso!!!' })      
      this.verifica(token);
    } else {
        this.setState({ mensagem: 'fudeu bahia!!!' })      
    }
  }

  verifica = token => {
    paypal.billingAgreement.execute(token, {}, function(
      error,
      billingAgreement
    ) {
      if (error) {
        console.error(error);
        throw error;
      } else {
        console.log(JSON.stringify(billingAgreement));
      }
    });
  };

  render() {
    return (
      <div className="container">
        <h1>{this.state.mensagem}</h1>
      </div>
    );
  }
}

export default Pagamento;
